export default "__VITE_ASSET__62434a87__"